import * as React from "react";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select, { SelectProps } from "@mui/material/Select";

type FdSelectProps = SelectProps & {
  label?: string;
  placeholder?: string;
  errorMsg?: string;
  required?: boolean;
  containerSx?: string;
  success?: boolean;
  textPosition?: string;
  helperText?: string;
  value?: string;
  error?: boolean;
  disabled?: boolean;
  name: string;
  defaultValue?: string;
  requiredText?: string;
  onChange: () => void;
  children: React.ReactNode;
}

const FdSelect = ({
  label,
  error,
  children,
  required,
  onChange,
  value,
  helperText,
  ...rest
}: FdSelectProps) => {
  return (
    <FormControl fullWidth error={error}>
      <InputLabel required={required}>{label}</InputLabel>
      <Select value={value} onChange={onChange} label={label}  {...rest}>
        {children}
      </Select>
    </FormControl>
  );
};

export default FdSelect;
